import { MailCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const NEXT_STEPS = ['signup.sent.next.confirm', 'signup.sent.next.review', 'signup.sent.next.access'] as const

/** Demande envoyée : ce qui va se passer, dans l'ordre (#279). */
function SignupSent({ email }: { email: string }) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col items-center gap-4 rounded-2xl border border-border bg-muted/50 px-6 py-8 text-center">
        <span className="flex size-16 items-center justify-center rounded-full bg-primary text-primary-foreground">
          <MailCheck className="size-8" aria-hidden />
        </span>
        <p className="text-sm text-muted-foreground">{t('signup.sent.description', { email })}</p>
      </div>
      <div>
        <h2 className="font-heading text-lg font-semibold">{t('signup.sent.next.title')}</h2>
        <ol className="mt-3 flex flex-col gap-3">
          {NEXT_STEPS.map((key, index) => (
            <li key={key} className="flex items-start gap-3 text-sm">
              <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-accent font-semibold text-accent-foreground" aria-hidden>
                {index + 1}
              </span>
              <span className="pt-1">{t(key)}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  )
}

export default SignupSent
